import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";
const API_BASE = getApiBaseUrl();

export async function saveLog(token: string, type: number, total_minutes: number): Promise<void> {
  return await apiFetch(`${API_BASE}/api/management/log`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({type: type, total_minutes: total_minutes, log_date: new Date().toISOString()}),
  });
}
